import React, { Component } from 'react';
import $ from 'jquery';

export default class Reset extends Component {
    constructor(props)
    {
      super(props);
    }
    requestPassword()
    {
      //http://mbadmin.nebi.co.kr/api/main/sendTmpPasswd
      let email = $('#email').val();
      if( email == "" )
      {
        alert('이메일 주소를 입력해주세요');
        return false;
      }
      $.post("https://api.tfamily.co.kr/api/main/sendTmpPasswd",{email:email},function(){
        alert('비밀번호 재설정 메일 발송되었습니다.');
      });
    }
    render()
    {
        let self = this;
        return (
        <div>
            <div className="centralize-wrapper">
                <div className="centralize-inner">
                    <div className="centralize-content">
                        <div className="login-box">
                            <div className="login-box-body">
                                <div className="row text-right">
                                  <a href="/">돌아가기</a>
                                  <br/>
                                </div>
                                <div className="row pb30">
                                    <span className="redpoint"></span>
                                    <h1 className="mb0 mt5"><b>재설정</b></h1>
                                    <div>가입시 입력하신 이메일 주소를 입력해주세요.</div>
                                </div>
                                <form className="mt10">
                                    <div className="form-group">
                                        <div className="row">
                                        <label htmlFor="email"><b>이메일</b></label>
                                        <input type="email" className="form-control loginform" id="email" placeholder="이메일을 입력해주세요"/>
                                        </div>
                                    </div>
                                    <div className="form-group mt30">
                                        <div className="row">
                                        <a onClick={()=>{self.requestPassword()}} className="col-xs-12 btn btn-baru">비밀번호 재설정</a>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
    }
}
